import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'MyTimeSheet',
        'Angular Admin Template with Bootstrap 4',
        {
            menu: 'vertical', //horizontal , vertical
            menuType: 'compact', //default, compact, mini
            showMenu: true,
          navbarIsFixed: true,
          footerIsFixed: false,
            sidebarIsFixed: true,
          showSideChat: false,
          sideChatIsHoverable: false,
          skin:'green'  //light , dark, blue, green, combined, purple, orange, brown, grey, pink
        }
    )
}
